import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSite } from "./SiteContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GetParam from '../api/GetParam';
import { useEffect } from 'react';

const SiteList = ({ dataValues = [] }) => {
  const navigate = useNavigate(); // Get the navigate function from React Router
  const { selectedSite, setSelectedSite } = useSite();
  const location = useLocation(); // Get the current location
  const { siteId } = useParams();

  useEffect(() => {
    setSelectedSite(siteId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const HandleChange = (event) => {
    const currentPath = location.pathname;
    const currentData = GetParam('dateRange', location)

    const newPath = currentPath.replace(/\/projects\/[^/]+/, `/projects/${event.target.value}`);
    setSelectedSite(event.target.value)
  
    // Navigate to new url
    navigate(newPath+'?dateRange=' + currentData);
  };

  return (
    <FormControl sx={{ width:{xl:'250px', lg:'250px', md:'230px', sm:'200px', xs:'140px'}}}>
    <InputLabel shrink={true} sx={{color:'black'}} id="site-selector-label">Selecteer locatie</InputLabel>
      <Select
          labelId='site-selector-label'
          value={selectedSite}
          onChange={(e) => HandleChange(e)}
          sx={{ width: '100%', height: '30px', color: '#141414', fontFamily:'Source Sans Pro,sans-serif !important'}}
          label='Selecteer locatie'
      >
        {dataValues.map(element => (<MenuItem key={element.id.val} value={element.id.val}>{element.navName}</MenuItem>))}
      </Select>
    </FormControl>
  );
}
export default SiteList;
